module.exports = __webpack_public_path__ + "img/4_uk.2c6c51bc.svg";